<script lang="ts">
  import { Button, type ButtonProps } from "$lib/components/ui/button"
  import type { HTMLButtonAttributes } from "svelte/elements"
  import { createEventDispatcher } from "svelte"

  interface Props {
    stopPropagation?: boolean
    variant?: $$Props["variant"]
    size?: $$Props["size"]
    builders?: $$Props["builders"]
    isLoading?: boolean
    disabled?: boolean
    class?: string | undefined
    children?: import("svelte").Snippet
    [key: string]: any
  }

  let {
    stopPropagation = false,
    variant = "default",
    size = "default",
    isLoading = false,
    disabled = false,
    class: className = undefined,
    children,
    ...rest
  }: Props = $props()

  const dispatch = createEventDispatcher()

  function handleClick(event) {
    if (stopPropagation) {
      event.stopPropagation()
    }
    dispatch("click", event)
  }
</script>

<Button
  {variant}
  {size}
  class={className}
  onclick={handleClick}
  {...rest}
  disabled={disabled || isLoading}
>
  {#if isLoading}
    <div
      class="h-4 w-4 animate-spin rounded-full border-b-2 border-white"
      class:!border-black={variant === "outline"}
    ></div>
  {:else}
    {@render children?.()}
  {/if}
</Button>
